import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth-context.js";
import { LoginForm, useProviders } from "../features/auth/index.js";
import { LoadingSpinner } from "../components/index.js";
import { useT } from "../i18n/index.js";

export function LoginPage() {
  const t = useT();
  const { user, isLoading } = useAuth();
  const { providers, isLoading: providersLoading } = useProviders();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && user) navigate("/admin/quizzes");
  }, [isLoading, user, navigate]);

  if (isLoading || providersLoading || !providers) return <LoadingSpinner />;

  return (
    <main className="page-center">
      <div className="card">
        <div style={{ textAlign: "center", marginBottom: "var(--space-lg)" }}>
          <span
            style={{
              display: "inline-block",
              background: "var(--brand)",
              color: "#fff",
              borderRadius: "var(--radius-md)",
              padding: "0.35rem 0.875rem",
              fontWeight: 800,
              fontSize: "var(--text-lg)",
              letterSpacing: "0.02em",
              marginBottom: "var(--space-sm)",
            }}
          >
            HootApp
          </span>
          <h1
            style={{
              margin: 0,
              fontSize: "var(--text-xl)",
              fontWeight: 800,
              color: "var(--text)",
            }}
          >
            {t("auth.signIn")}
          </h1>
        </div>
        <hr style={{ height: "1px", background: "var(--border)", border: "none", margin: "var(--space-lg) 0" }} />
        <LoginForm registrationMode={providers.registrationMode} />
      </div>
    </main>
  );
}
